/*
  Best-selling order for featured collection sections.

  sections/section-collection.liquid marks itself with
  data-products-order="best-selling" (plus the collection URL and its product
  limit) when the merchant picks Best selling. The page ships in the
  collection's own order; this fetches sections/api-collection-order.liquid
  through the collection URL with sort_by=best-selling, which server-renders
  the same snippets/product-grid-item.liquid cards in sales order, and swaps
  the grid to match. Cards are never rebuilt in JS.

  Fidelity rule: when a fetched product is already on the page, the page's own
  node is reused (moved, not replaced), so its markup cannot drift from the
  first render. Fetched nodes only enter for products the first render did not
  include (a collection larger than the section's limit).

  Failure of any kind — network, non-200, empty render, fewer cards than are
  showing — leaves the DOM untouched: the collection's own order simply stays,
  which is the documented fallback, not an error state.

  Slider re-init: the grid-slider custom element listens for
  'theme:grid-slider:init', but its init() returns early once initialised and
  its is-visible IntersectionObserver only watches the nodes present at init.
  destroy() resets that flag and disconnects the observers (read from
  theme.js), so the sequence after a swap is destroy() then the init event.

  Injected cards animate by themselves: theme.js runs a document-wide
  MutationObserver that hands any new [data-aos] node to the AOS
  IntersectionObserver.
*/
(function () {
  'use strict';

  // The section renders one script tag per best-selling instance; the browser
  // caches the file but executes each tag, so only the first run proceeds.
  if (window.__phCollectionOrder) return;
  window.__phCollectionOrder = true;

  var SECTION = '[data-products-order="best-selling"]';

  // grid-item ids end "-<product id>" (product-item--<section id>-<product id>,
  // see snippets/product-grid-item.liquid item_unique). The section id differs
  // between the page render and the api render, the trailing product id does not.
  function productIdOf(item) {
    var match = (item.id || '').match(/-(\d+)$/);
    return match ? match[1] : null;
  }

  function init(section) {
    var url = section.getAttribute('data-collection-url');
    var limit = parseInt(section.getAttribute('data-order-limit'), 10) || 20;
    var grid = section.querySelector('[data-grid-slider], .grid');
    if (!url || !grid) return;

    var sep = url.indexOf('?') === -1 ? '?' : '&';

    fetch(url + sep + 'sort_by=best-selling&section_id=api-collection-order')
      .then(function (response) {
        if (!response.ok) throw new Error('collection-order: HTTP ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fetched = Array.prototype.slice
          .call(doc.querySelectorAll('[data-api-content] [data-grid-item]'))
          .slice(0, limit);
        var existing = Array.prototype.slice.call(grid.querySelectorAll('[data-grid-item]'));

        if (!fetched.length || !existing.length) return;
        // Fewer cards than are showing would blank part of the row; keep the
        // server order instead.
        if (fetched.length < existing.length) return;

        var byProductId = {};
        existing.forEach(function (item) {
          var id = productIdOf(item);
          if (id) byProductId[id] = item;
        });

        var changed = false;
        var ordered = fetched.slice(0, existing.length).map(function (item, i) {
          var id = productIdOf(item);
          var node = (id && byProductId[id]) || item;
          if (node !== existing[i]) changed = true;
          return node;
        });
        if (!changed) return;

        // Everything parsed and resolved before the first mutation, so a
        // failure above can never leave the grid half-swapped.
        grid.replaceChildren.apply(grid, ordered);

        var slider = section.querySelector('grid-slider');
        if (slider) {
          if (typeof slider.destroy === 'function') slider.destroy();
          slider.dispatchEvent(new CustomEvent('theme:grid-slider:init'));
        }
      })
      .catch(function () {
        // Silent by design, matching the delivery bar: the page's own order is
        // already correct markup, so a failed reorder should look like nothing
        // happened - not log to every visitor's console (red team).
      });
  }

  document.querySelectorAll(SECTION).forEach(init);

  // Theme editor re-renders replace the section wholesale; the file-level
  // execution guard above blocks re-running the SCRIPT, not re-initialising a
  // fresh section. changed=false paths make a duplicate call a no-op.
  document.addEventListener('shopify:section:load', function (e) {
    (e.target || document).querySelectorAll(SECTION).forEach(init);
  });
})();
